import {
  FormControlLabel,
  Grid,
  Typography,
  WithStyles,
  makeStyles,
  Checkbox
  //CircularProgress
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import { useState,useEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import {
  ReduxFormField,
  ReduxDatePicker
} from '../../../components/FormInput/ReduxWrappers'
// import TermsFrame from '../../../components/TernsFrame/TermsFrame'
import {
  onlyNumsAndDecimals,
  charsSpaceNums
} from '../../../libs/normalize/information'
import {
  selectApartmentById,
  selectBeforeLoginApartment
} from '../../../selectors/apartments'
import { selectContentIdFromPathname } from '../../../selectors/router'
import { selectIsMobile } from '../../../selectors/users'
import { ReduxForm } from '../../../types/forms'
import {
  WaterFeeBasis,
  RentPeriodOptions,
  SecurityDepositOptions,
  NoticeTimeOptions,
  Parking,
  AnnouncementTypeOptions
} from '../../../types/propValues/apartments'
// import { ShowingTypes } from '../../../types/showings'
import { StateInterface } from '../../../types/states'

import {
  required,
  // requiredFalsyString,
  greaterThanAvailableFrom,
  noSpacesPhoneNum,
  validateEmail,
  validatePassword,
  noSpaceValue,
  validatePhoneNumber,
  isInvalidCharacters,
  stripSpaces
} from '../../../utils/validation/forms'
import { MyApartmentRadio, MyInput } from '../../NewApplication/Fields'
import { BackButton } from '../Stepper/BackButton'
import NextStepButton from '../Stepper/NextStepButton'
import Suggest from '../Stepper/Steps/Suggest'
import SubmitButton from '../Stepper/SubmitButton'
import { getValuesAndLabels } from './values/apartmentProperties'

const useStyles = makeStyles(({ breakpoints }) => ({
  Accordion: {
    marginTop: '15px'
  },
  panelDetails: {
    display: 'block',
    height: '300px',
    padding: 0,
    overflow: 'hidden'
  },
  panelTitle: {
    marginTop: '15px',
    backgroundColor: '#bdbdbd'
  },
  confirmRow: {
    '& > label': {
      alignItems: 'start'
    }
  },
  checkboxes: {
    marginLeft: '0',
    marginRight: '0',
    alignItems: 'start',
  },
  // confirmField: {
  //   marginTop: '16px !important'
  // },
  confirmTextDiv: {
    padding: '25px 0 25px 0',
    marginLeft: '5px'
  },
  checkboxContainer2: {
    alignItems: 'center !important',
    backgroundColor: '#FBF6EE',
    borderRadius: '10px'
  },
  checkboxHighlightBox: {
    backgroundColor: '#FBF6EE',
    borderRadius: '10px',
    width: '100%',
    marginTop: '10px',
    border: '1px solid #F1D9C0',
    padding: '0 0 0px 5px'
  },
  infoBoxWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    [breakpoints.between('sm', 'md')]: {
      justifyContent: 'center'
    }
  },
  announcementInfoBox: {
    marginTop: '12px',
    marginBottom: '20px',
    padding: '16px',
    backgroundColor: '#E2EBFD',
    borderRadius: '8px',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: 500
  }
}))
interface ApartmentConfirmationFormProps
  extends WithStyles,
  WithTranslation,
  ReduxForm {
  updateApartmentConfirmation: (arg: any) => any
  isDisabled: boolean
  isTemporaryRentPeriod: boolean
  isFormerlyValid: boolean
  waterFeeBasis: WaterFeeBasis | undefined
  waterFeeAdornment: string
  rentPrice: string
  rentPeriod: string
  announcementType: string
  confirm: boolean
  securityDeposit: string
  showParkingFee: boolean
  showSecurityDepositAmount: boolean
  isSVAMember: boolean
  isBeforeLogin?: boolean
  createdAt: number | undefined
  currentStep: any
  doStepBack: any
  isMobile: any
  beforeLogin?: boolean
  availableUntilDate?: any
  availableFromDate?: any
  name: string
  phoneNumber: string
  email: string
  password: string
  vuokraoviCollateral?: boolean
  contactInfoPublicOnPlatforms?: boolean
}

// const getWaterFeeAdornment = (waterFeeBasis: WaterFeeBasis) => {
//   const abbreviation =
//     waterFeeBasis === 'perTenant' || waterFeeBasis === 'metered'
//       ? 'perPersonPerMonth'
//       : 'perMonth'
//   return `€${i18n.t(`abbreviations.${abbreviation}`)}`
// }

export const showParking = (parking: Parking | undefined): boolean =>
  parking ? parking !== 'no' && parking !== 'notSure' : false

const ApartmentConfirmationForm = ({
  t,
  handleSubmit,
  submitting,
  error,
  updateApartmentConfirmation,
  classes,
  isDisabled,
  isTemporaryRentPeriod,
  isFormerlyValid,
  waterFeeBasis,
  showParkingFee,
  rentPrice,
  rentPeriod,
  announcementType,
  securityDeposit,
  showSecurityDepositAmount,
  confirm,
  isSVAMember,
  isBeforeLogin,
  createdAt,
  doStepBack,
  currentStep,
  isMobile,
  beforeLogin,
  availableUntilDate,
  availableFromDate,
  name,
  phoneNumber,
  email,
  password,
  vuokraoviCollateral,
  contactInfoPublicOnPlatforms
}: ApartmentConfirmationFormProps) => {
  const styles = useStyles()
  const [isEmpty, setIsEmpty] = useState(false)
  const [vuokraoviCollateralAccepted, setVuokraoviCollateralAccepted] = useState(false)
  const [contactInfoPublicOnPlatformsAccepted, setContactInfoPublicOnPlatformsAccepted] = useState(false)

  const isBeforeLoginFlow = Boolean(beforeLogin)
  const showAnnouncementStep = isBeforeLoginFlow && currentStep === 9
  const showContractStep =
    (!isBeforeLoginFlow && currentStep === 9) ||
    (isBeforeLoginFlow && currentStep === 10)
  const showContactStep =
    (!isBeforeLoginFlow && currentStep === 10) ||
    (isBeforeLoginFlow && currentStep === 11)

  const contactStepHeadingKey = isBeforeLoginFlow
    ? currentStep === 11
      ? 'step10heading'
      : 'step9announcementHeading'
    : currentStep === 10
      ? 'step9announcementHeading'
      : 'step10heading'

  const renderAnnouncementTypeSelector = () => (
    <Grid className={classes.containerItem} item xs={12} sm={12}>
      <Typography variant='body1' gutterBottom>
        {t('apartment.announcementType.label')}
      </Typography>
      <ReduxFormField
        name='announcementType'
        select
        required
        component={MyApartmentRadio}
        validate={[required]}
        disabled={isDisabled}
        items={getValuesAndLabels(
          AnnouncementTypeOptions,
          'announcementType'
        ).map(({ value, label }) => [value, t(label)])}
      />
      <Typography variant='body2' className={styles.announcementInfoBox}>
        {t('apartment.announcementType.helper')}
      </Typography>
    </Grid>
  )

  const handleVuokraoviCollateralAcceptedCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setVuokraoviCollateralAccepted(isChecked)

    if (isChecked) {
      localStorage.setItem('vuokraoviCollateral', 'true')
    } else {
      localStorage.setItem('vuokraoviCollateral', 'false')
    }
  }

  const handlecontactInfoPublicOnPlatformsAcceptedCheckboxChange = (event) => {
    const isChecked = event.target.checked
    setContactInfoPublicOnPlatformsAccepted(isChecked)

    if (isChecked) {
      localStorage.setItem('contactInfoPublicOnPlatforms', 'true')
    } else {
      localStorage.setItem('contactInfoPublicOnPlatforms', 'false')
    }
  }

  useEffect(() => {
    const isAccepted =
      vuokraoviCollateral === true || vuokraoviCollateral === 'true'
    setVuokraoviCollateralAccepted(isAccepted)
    localStorage.setItem('vuokraoviCollateral', isAccepted ? 'true' : 'false')
  }, [vuokraoviCollateral])

  useEffect(() => {
    const isAccepted =
      contactInfoPublicOnPlatforms === true ||
      contactInfoPublicOnPlatforms === 'true'
    setContactInfoPublicOnPlatformsAccepted(isAccepted)
    localStorage.setItem(
      'contactInfoPublicOnPlatforms',
      isAccepted ? 'true' : 'false'
    )
  }, [contactInfoPublicOnPlatforms])

  return (
    <form onSubmit={handleSubmit(updateApartmentConfirmation)}>
      <Grid container justify='space-between'>
        <Grid container>
          {showAnnouncementStep && (
            <>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step9announcementHeading')}
                      </Typography>
                    </Grid>
                    {renderAnnouncementTypeSelector()}
                    <Grid item xs={12}>
                      <Typography
                        variant='h5'
                        className={styles.contactSubheading}
                        style={{ marginTop: '12px', marginBottom: '6px' }}
                      >
                        {t('apartment.announcementType.contact')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      className={styles.confirmRow}
                      style={{ marginTop: '-3px' }}
                    >
                      <div className={styles.checkboxHighlightBox}>
                        <FormControlLabel
                          className={`${styles.checkboxes} ${styles.checkboxContainer2}`} // Add styles from ReduxCheckbox
                          control={
                            <Checkbox
                              checked={contactInfoPublicOnPlatformsAccepted}
                              onChange={
                                handlecontactInfoPublicOnPlatformsAcceptedCheckboxChange
                              }
                              style={{ color: '#94004A' }} // Custom color as needed
                            //className={styles.confirmField} // Apply any specific styles for Checkbox
                            //disabled={isDisabled}
                            />
                          }
                          label={
                            <div className={styles.confirmTextDiv}>
                              {t('apartment.contactInfoPublicOnPlatformsCheckboxText')}
                            </div>
                          }
                        />
                      </div>
                    </Grid>
                    {isEmpty && (
                      <div className={classes.validationContainer}>
                        <Typography style={{ color: 'red' }} variant='body1'>
                          {t('apartment.actions.stepFail')}
                        </Typography>
                      </div>
                    )}
                    <Grid
                      container
                      className={classes.buttonContainer}
                      style={beforeLogin ? { marginTop: '24px' } : undefined}
                    >
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{ announcementType }}
                          toCheck={{}}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      desktopMaxWidth="450px"
                      content={t('apartment.hints.step9AnnouncementHint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          )}

          {showContractStep && (
            <>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step9heading')}
                      </Typography>
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.rentPeriod.label')}
                      </Typography>
                      <ReduxFormField
                        name='rentPeriod'
                        select
                        required
                        component={MyApartmentRadio}
                        validate={[required]}
                        disabled={isDisabled}
                        style={{ width: '90%' }}
                        items={getValuesAndLabels(
                          RentPeriodOptions,
                          'rentPeriod'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {isFormerlyValid && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className={classes.containerItem}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.rentPeriod.noticeTime')}
                        </Typography>
                        {/* <Field
                          fullWidth
                          name='noticeTime'
                          required
                          style={{
                            width: '100%',
                            height: '58px',
                            padding: '20px',
                            background: '#E7ECEF'
                          }}
                          component={MyInput}
                          normalize={charsSpaceNums}
                        /> */}
                        <ReduxFormField
                          name='noticeTime'
                          select
                          component={MyApartmentRadio}
                          required
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            NoticeTimeOptions,
                            'noticeTime'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                    )}
                    {isTemporaryRentPeriod && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        className={classes.containerItem}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.availableUntilDate')}
                        </Typography>
                        <Grid item xs={12} className={classes.datePicker}>
                          <DateRangeIcon />
                          <Field
                            fullWidth
                            name='availableUntilDate'
                            invalidLabel=''
                            required
                            validate={[required, greaterThanAvailableFrom]}
                            component={ReduxDatePicker}
                          />
                        </Grid>
                      </Grid>
                    )}
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.securityDeposit.label')}
                      </Typography>
                      <ReduxFormField
                        name='securityDeposit'
                        select
                        component={MyApartmentRadio}
                        required
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          SecurityDepositOptions,
                          'securityDeposit'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {showSecurityDepositAmount && (
                      <Grid item xs={12} sm={12}>
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.securityDepositAmount')}
                        </Typography>
                        <ReduxFormField
                          name='securityDepositAmount'
                          required
                          InputProps={{ min: 0, step: 0.01, endAdornment: '€' }}
                          disabled={isDisabled}
                          component={MyInput}
                          style={{
                            width: '100%',
                            height: '58px',
                            padding: '20px',
                            background: '#E7ECEF'
                          }}
                          type='number'
                          normalize={onlyNumsAndDecimals}
                          validate={[required]}
                        />
                      </Grid>
                    )}
                    {/* <Grid item xs={12} sm={12}>
                      <Typography variant='body1' gutterBottom>
                        {t('apartment.rentPrice')}
                      </Typography>
                      <ReduxFormField
                        name='price'
                        required
                        InputProps={{ min: 0, step: 0.01, endAdornment: '€' }}
                        disabled={isDisabled}
                        component={MyInput}
                        style={{
                          width: '100%',
                          height: '58px',
                          padding: '20px',
                          background: '#E7ECEF'
                        }}
                        type='number'
                        normalize={onlyNumsAndDecimals}
                        validate={[required]}
                      />
                    </Grid> */}
                    <Grid item xs={12}>
                      <div className={styles.checkboxHighlightBox}>
                        <FormControlLabel
                          className={`${styles.checkboxes} ${styles.checkboxContainer2}`} // Add styles from ReduxCheckbox
                          control={
                            <Checkbox
                              checked={vuokraoviCollateralAccepted}
                              onChange={handleVuokraoviCollateralAcceptedCheckboxChange}
                              style={{ color: '#94004A' }} // Custom color as needed
                              //className={styles.confirmField} // Apply any specific styles for Checkbox
                            //disabled={isDisabled}
                            />
                          }
                          label={
                            <div className={styles.confirmTextDiv}>
                              {t('apartment.vuokraoviCollateralCheckboxText')}
                            </div>
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>
                      {isEmpty && (
                        <div className={classes.validationContainer}>
                          <Typography style={{ color: 'red' }} variant='body1'>
                            {t('apartment.actions.stepFail')}
                          </Typography>
                        </div>
                      )}
                  <Grid container className={classes.buttonContainer}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        toValidate={{
                          rentPeriod: rentPeriod,
                          securityDeposit: securityDeposit
                        }}
                        toCheck={{
                          availableUntilDate: availableUntilDate
                            ? availableUntilDate['_d'] < availableFromDate
                            : ''
                        }}
                        setIsEmpty={setIsEmpty}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step9Hint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>{' '}
            </>
          )}

          {showContactStep && (
            <>
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    {' '}
                    <Typography variant='h5' gutterBottom>
                      {t(`apartment.steps.${contactStepHeadingKey}`)}
                    </Typography>
                    <Grid item container xs={12}>
                      <Grid container spacing={1}>
                        {!isBeforeLoginFlow && renderAnnouncementTypeSelector()}
                        {beforeLogin && (
                          <>
                            <Grid item sm={12}>
                              <Typography variant='subtitle2' gutterBottom>
                                {t('signup.passwordHelper')}
                              </Typography>
                            </Grid>
                            {/* Additional notes field removed */}
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.fullName')}
                              </Typography>
                              <ReduxFormField
                                name='name'
                                validate={[required, isInvalidCharacters]}
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.phoneNum')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='tel'
                                name='phoneNumber'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                validate={[
                                  required,
                                  noSpacesPhoneNum,
                                  validatePhoneNumber,
                                ]}
                                required
                              />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.email')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='username'
                                name='email'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                validate={[
                                  required,
                                  noSpaceValue,
                                  validateEmail
                                ]}
                                normalize={stripSpaces}
                                required
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('person.password')}
                              </Typography>
                              <ReduxFormField
                                autoComplete='new-password'
                                name='password'
                                component={MyInput}
                                style={{
                                  width: '100%',
                                  height: '58px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                type='password'
                                helperText={t('changePw.helperText')}
                                validate={[
                                  required,
                                  validatePassword,
                                  noSpaceValue
                                ]}
                                required
                              />
                            </Grid>
                          </>
                        )}
                          {/* Additional notes field removed for afterLogin */}
                        {!beforeLogin && (
                          <>
                            <Grid item xs={12}>
                              <Typography
                                variant='h5'
                                className={styles.contactSubheading}
                              >
                                {t('apartment.announcementType.contact')}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={12}
                              className={styles.confirmRow}
                              style={{ marginBottom: '-3px', marginTop: '-5px' }}
                            >
                              <div className={styles.checkboxHighlightBox}>
                                <FormControlLabel
                                  className={`${styles.checkboxes} ${styles.checkboxContainer2}`} // Add styles from ReduxCheckbox
                                  control={
                                    <Checkbox
                                      checked={contactInfoPublicOnPlatformsAccepted}
                                      onChange={handlecontactInfoPublicOnPlatformsAcceptedCheckboxChange}
                                      style={{ color: '#94004A' }} // Custom color as needed
                                    //className={styles.confirmField} // Apply any specific styles for Checkbox
                                    //disabled={isDisabled}
                                    />
                                  }
                                  label={
                                    <div className={styles.confirmTextDiv}>
                                      {t('apartment.contactInfoPublicOnPlatformsCheckboxText')}
                                    </div>
                                  }
                                />
                              </div>
                            </Grid>
                          </>
                        )}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          className={styles.confirmRow}
                          style={{ marginBottom: '10px' }}
                        >
                          <div className={styles.checkboxHighlightBox}>
                            <Field
                              name='confirm'
                              component={({ input }) => (
                                <FormControlLabel
                                  className={`${styles.checkboxes} ${styles.checkboxContainer2}`}
                                  control={
                                    <Checkbox
                                      checked={Boolean(input.value)}
                                      onChange={(_, checked) => input.onChange(checked)}
                                      style={{ color: '#94004A' }}
                                      disabled={isDisabled}
                                    />
                                  }
                                  label={
                                    <div className={styles.confirmTextDiv}>
                                      {t('apartment.confirmation.confirmPart')}

                                      <a
                                        style={{
                                          textDecoration: 'none',
                                          color: 'inherit'
                                        }}
                                        target='blank'
                                        href='https://leea.fi/kayttoehdot/'
                                      >
                                        {t('apartment.confirmation.confirmPartLink1')}
                                      </a>
                                      {t('apartment.confirmation.confirmDivider')}
                                      <a
                                        style={{
                                          textDecoration: 'none',
                                          color: 'inherit'
                                        }}
                                        target='blank'
                                        href='https://leea.fi/tietosuojaseloste/'
                                      >
                                        {t('apartment.confirmation.confirmPartLink2')}
                                      </a>
                                    </div>
                                  }
                                />
                              )}
                            />
                          </div>
                        </Grid>
                      </Grid>
                      {showParkingFee && (
                        <Grid item xs={12} lg={6}>
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.parkingFee')}
                          </Typography>
                          <ReduxFormField
                            name='parkingFee'
                            type='number'
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            InputProps={{
                              min: 0,
                              step: 0.01,
                              endAdornment: '€'
                            }}
                            normalize={onlyNumsAndDecimals}
                            disabled={isDisabled}
                          />
                        </Grid>
                      )}
                    </Grid>
                    <Grid item sm={12} xs={12} style={{ marginTop: '15px' }}>
                      <ErrorMessage error={error} />
                      <Grid container>
                        <Grid item xs={4}>
                          <BackButton
                            currentStep={currentStep}
                            doStepBack={doStepBack}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          {/* STEP 10 SUBMIT IS HAPPENING HERE */}
                          <SubmitButton
                            t={t}
                            submit={!isDisabled}
                            setIsEmpty={setIsEmpty}
                            toCheck={{
                              name: isInvalidCharacters(name),
                              phoneNumber:
                                noSpacesPhoneNum(phoneNumber) ||
                                validatePhoneNumber(phoneNumber),
                              email:
                                noSpaceValue(email) || validateEmail(email),
                              password:
                                validatePassword(password) ||
                                noSpaceValue(password)
                            }}
                            externalIsLoading={submitting}
                            customLabel={
                              <> {t('apartment.actions.confirm')}</>
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest desktopMaxWidth="450px" content={t('apartment.hints.step10Hint')}
                      containerMaxWidth='550px'
                      contentMaxWidth='450px'
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>{' '}
    </form>
  )
}

const selector = formValueSelector('ApartmentConfirmationForm')

const mapStateToProps = (
  state: StateInterface,
  ownProps: { isBeforeLogin: boolean }
) => {
  let apartment
  if (ownProps.isBeforeLogin) {
    apartment = selectBeforeLoginApartment(state)
  } else {
    const apartmentId = selectContentIdFromPathname(state)
    apartment = apartmentId
      ? selectApartmentById(apartmentId)(state)
      : undefined
  }
  const isSVAMemberValue = selector(state, 'isSVAMember')
  return {
    isTemporaryRentPeriod: selector(state, 'rentPeriod') === 'temporary',
    isFormerlyValid: selector(state, 'rentPeriod') === 'formerlyValid',
    waterFeeBasis: selector(state, 'waterFeeBasis'),
    showSecurityDepositAmount: selector(state, 'securityDeposit') === 'other',
    rentPrice: selector(state, 'price'),
    rentPeriod: selector(state, 'rentPeriod'),
    announcementType: selector(state, 'announcementType'),
    availableUntilDate: selector(state, 'availableUntilDate'),
    availableFromDate: selector(state, 'availableFromDate'),
    confirm: selector(state, 'confirm'),
    securityDeposit: selector(state, 'securityDeposit'),
    showParkingFee: showParking(apartment?.information?.parking),
    isSVAMember: isSVAMemberValue === true || isSVAMemberValue === 'true',
    isMobile: selectIsMobile(state),
    name: selector(state, 'name'),
    phoneNumber: selector(state, 'phoneNumber'),
    email: selector(state, 'email'),
    password: selector(state, 'password')
  }
}

export default connect(mapStateToProps)(
  reduxForm({
    form: 'ApartmentConfirmationForm'
  })(withTranslation()(ApartmentConfirmationForm as any) as any) as any
) as any
